import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Avatar } from '../../../Avatar/Avatar.tsx';
import styles from './UIGameActionBoxPickPlayer.module.scss';
import clsx from 'clsx';
import { UIGameActionBoxBase } from '../../UIGameActionBoxBase.tsx';
import { UIGameFloatingText } from '../../../UIGameFloatingText/index.ts';
import { UIGamePlayerInfoHeaderPointsPublic } from '../../../../core/UIGamePlayerInfo/UIGamePlayerInfoHeader/UIGamePlayerInfoHeaderPointsPublic/UIGamePlayerInfoHeaderPointsPublic.tsx';
import { getPublicVictoryPoints } from './UIGameActionBoxPickPlayerUtils.ts';
const AUTO_DISMISS_DELAY_MS = 1500;
export const UIGameActionBoxPickPlayer = ({ playerValidators, onConfirm, onClose, onPlayerSelect, isConfirmDisabled, body, isPlayerSelectable, invalidPlayerTooltip, noValidTargetsBody, showVictoryPoints, ...baseProps })=>{
    const [selectedPlayer, setSelectedPlayer] = useState(undefined);
    const autoDismissTimerRef = useRef(undefined);
    const validPlayerColors = playerValidators.filter(isPlayerSelectable !== null && isPlayerSelectable !== void 0 ? isPlayerSelectable : ()=>true).map((v)=>v.color);
    const hasNoValidTargets = validPlayerColors.length === 0;
    const noPlayerSelected = selectedPlayer == undefined;
    useEffect(()=>{
        const hasSelectedPlayer = !noPlayerSelected;
        const isSelectedValid = hasSelectedPlayer ? validPlayerColors.includes(selectedPlayer) : false;
        const selectedIsNowInvalid = hasSelectedPlayer && !isSelectedValid;
        const onlyOneValidRemains = validPlayerColors.length === 1;
        const shouldSelectOnlyValidPlayer = noPlayerSelected && onlyOneValidRemains;
        const shouldUpdateSelection = selectedIsNowInvalid || shouldSelectOnlyValidPlayer;
        if (!shouldUpdateSelection) return;
        const autoSelectedPlayer = onlyOneValidRemains ? validPlayerColors[0] : undefined;
        setSelectedPlayer(autoSelectedPlayer);
        if (autoSelectedPlayer != undefined) {
            onPlayerSelect === null || onPlayerSelect === void 0 ? void 0 : onPlayerSelect(autoSelectedPlayer);
        }
    }, [
        playerValidators
    ]);
    useEffect(()=>{
        if (!hasNoValidTargets) return;
        autoDismissTimerRef.current = setTimeout(()=>{
            if (!onClose) return;
            onClose();
        }, AUTO_DISMISS_DELAY_MS);
        return ()=>{
            clearTimeout(autoDismissTimerRef.current);
        };
    }, [
        hasNoValidTargets
    ]);
    const handlePlayerClick = (playerColor)=>{
        const isValid = validPlayerColors.includes(playerColor);
        if (!isValid) return;
        setSelectedPlayer(playerColor);
        if (!onPlayerSelect) return;
        onPlayerSelect(playerColor);
    };
    const getIsConfirmDisabled = ()=>{
        if (hasNoValidTargets) return true;
        if (isConfirmDisabled) return true;
        if (noPlayerSelected) return true;
        return false;
    };
    const shouldDisableConfirm = getIsConfirmDisabled();
    const handleConfirm = useCallback(()=>{
        if (!noPlayerSelected) onConfirm();
    }, [
        noPlayerSelected,
        onConfirm
    ]);
    const getActiveBody = ()=>{
        if (hasNoValidTargets && noValidTargetsBody) {
            return noValidTargetsBody;
        }
        return body;
    };
    const activeBody = getActiveBody();
    return /*#__PURE__*/ React.createElement(UIGameActionBoxBase, {
        ...baseProps,
        body: activeBody,
        isConfirmDisabled: shouldDisableConfirm,
        onConfirm: handleConfirm,
        ...onClose != undefined && {
            onClose: onClose
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.playerGrid
    }, playerValidators.map((playerValidator)=>{
        const isValid = validPlayerColors.includes(playerValidator.color);
        const isSelected = selectedPlayer === playerValidator.color;
        const playerOption = /*#__PURE__*/ React.createElement("div", {
            className: clsx(styles.playerOption, {
                [styles.selected]: isSelected,
                [styles.invalid]: !isValid
            }),
            key: playerValidator.color,
            onClick: ()=>handlePlayerClick(playerValidator.color)
        }, /*#__PURE__*/ React.createElement("div", {
            className: styles.playerAvatarWrapper
        }, /*#__PURE__*/ React.createElement(Avatar, {
            className: styles.playerAvatar,
            color: playerValidator.color,
            image: playerValidator.displayIcon,
            profilePictureUrl: playerValidator.profilePictureUrl
        }), showVictoryPoints && /*#__PURE__*/ React.createElement("div", {
            className: styles.vpBadge
        }, /*#__PURE__*/ React.createElement(UIGamePlayerInfoHeaderPointsPublic, {
            points: getPublicVictoryPoints(playerValidator),
            playerColor: playerValidator.color
        }))), /*#__PURE__*/ React.createElement("div", {
            className: styles.playerName
        }, playerValidator.username));
        if (invalidPlayerTooltip) {
            return /*#__PURE__*/ React.createElement(UIGameFloatingText, {
                direction: "up",
                disabled: isValid,
                key: playerValidator.color,
                text: invalidPlayerTooltip
            }, playerOption);
        }
        return playerOption;
    })));
};
